<template>
  <div class="pnl-attributes">
    <div v-for="attr in attrs" :key="attr.key" class="attr">
      <span class="name">
        {{ attr.title }}
        <Icon
          v-if="attr.icon"
          :icon="attr.icon"
          @click.native="showAlert(attr.alert)"
        />
      </span>
      <span :class="attr.cls">{{ attr.value }}</span>
    </div>
  </div>
</template>
<script>
import Icon from 'com/Icon'
import Modal from 'com/Modal'
import { SEC_TYPE } from 'const/stock'
import { mapGetters } from 'vuex'
export default {
  name: 'PnlAttributes',
  components: { Icon },
  props: {
    detail: Object
  },
  computed: {
    ...mapGetters(['isIb']),
    attrs() {
      const { floatNum, redGreen, precise, sign } = this.$options.filters
      return [
        this.detail.profitLoss && {
          key: 'pl',
          title: this.$t('trade.holdings-detail-page.holdings-pl'),
          value: sign(floatNum(this.detail.profitLoss, this.detail)),
          cls: [redGreen(this.detail.profitLoss)]
        },
        {
          key: 'rp',
          title: this.$t('trade.holdings-detail-page.real-pl'),
          value: sign(floatNum(this.realizedPnl, this.detail)),
          cls: [redGreen(this.realizedPnl)]
        },
        {
          key: 'sp',
          title: this.$t('trade.holdings-detail-page.stock-profit'),
          value: sign(floatNum(this.profit, this.detail)),
          cls: [redGreen(this.profit)]
        },
        this.detail.position && {
          key: 'ha',
          title: this.$t('trade.holdings-detail-page.hold-amount'),
          value: this.detail.position
        },
        this.detail.marketValue && {
          key: 'hmv',
          title: this.$t('trade.holdings-detail-page.hold-mkt-value'),
          value: floatNum(this.detail.marketValue, this.detail)
        },
        this.detail.averageCost && {
          key: 'hap',
          title: this.$t('trade.holdings-detail-page.hold-avg-price'),
          value: floatNum(this.detail.averageCost, this.detail)
        },
        this.guaranteedPrice && {
          key: 'gp',
          title: this.$t('trade.holdings-detail-page.guaranteed-price'),
          icon: 'help',
          alert: this.$t('trade.holdings-detail-page.guaranteed-content'),
          value: precise(this.guaranteedPrice)
        },
        {
          key: 'cry',
          title: this.currencyName,
          value: this.currency
        }
      ].filter(Boolean)
    },
    isOPT() {
      return this.detail.secType === SEC_TYPE.OPT
    },
    // 每股浮动收益
    profit() {
      return this.detail.latestPrice - this.detail.averageCost
    },
    // 总盈亏
    realizedPnl() {
      return this.isIb ? this.detail.realizedPnL : this.detail.realizedPnl
    },
    guaranteedPrice() {
      if (this.isOPT || !this.detail.position || !this.realizedPnl) return
      return this.detail.averageCost - this.realizedPnl / this.detail.position
    },
    currencyName() {
      return this.isOPT
        ? this.$t('trade.holdings-detail-page.opt-currency')
        : this.$t('trade.holdings-detail-page.stock-currency')
    },
    currency() {
      return { US: 'USD', HK: 'HKD' }[this.detail.market]
    }
  },
  methods: {
    showAlert(content) {
      Modal.open({
        title: this.$t('tip-title'),
        content,
        cancelButton: false
      })
    }
  }
}
</script>
<style lang="less" scoped>
.pnl-attributes {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
}
.attr {
  width: 48%;
  display: flex;
  justify-content: space-between;
  line-height: 20px;
}
.name {
  color: var(--sub-text-color);
}
</style>
